/* eslint-disable */
import * as Yup from 'yup';
import { translate } from '@cashfree-intl/coherent';
import { KYC_VALIDATION_REQUIRED_MSG } from '../../../../constants';

const kycFormvalidationSchema = (
  vendorTypeSelected,
  addressProof,
  isEditMode,
) => {
  return Yup.object({
    uidai:
      vendorTypeSelected === 'INDIVIDUAL' && addressProof === 1
        ? Yup.string()
            .length(
              12,
              `${translate('incorrect_aadhaar_please_enter_a_valid_aadhaar')}`,
            )
            .matches(
              /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
              `${translate('incorrect_aadhaar_please_enter_a_valid_aadhaar')}`,
            )
            .required(KYC_VALIDATION_REQUIRED_MSG)
            .trim()
        : Yup.string(),
    pan:
      vendorTypeSelected === 'INDIVIDUAL'
        ? Yup.string()
            .length(
              10,
              `${translate('incorrect_pan_please_enter_a_valid_pan')}`,
            )
            .matches(
              /[A-Z]{5}[0-9]{4}[A-Z]{1}/,
              `${translate('incorrect_pan_please_enter_a_valid_pan')}`,
            )
            .required(KYC_VALIDATION_REQUIRED_MSG)
            .trim()
        : Yup.string(),
    drivingLicense:
      vendorTypeSelected === 'INDIVIDUAL' && addressProof === 2
        ? Yup.string()
            .length(15, `${translate('length_must_be_15')}`)
            .matches(
              /^(([A-Z]{2}[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
              `${translate(
                'incorrect_driving_licence_please_enter_a_valid_driving_licence',
              )}`,
            )
            .required(KYC_VALIDATION_REQUIRED_MSG)
            .trim()
        : Yup.string(),
    voterId:
      vendorTypeSelected === 'INDIVIDUAL' && addressProof === 3
        ? Yup.string()
            .length(10, `${translate('length_must_be_10')}`)
            .matches(
              /^[A-Z]{3}[0-9]{7}$/,
              `${translate(
                'incorrect_voter_id_please_enter_a_valid_voter_id',
              )}`,
            )
            .required(KYC_VALIDATION_REQUIRED_MSG)
            .trim()
        : Yup.string(),
    passport:
      vendorTypeSelected === 'INDIVIDUAL' && addressProof === 4
        ? Yup.string()
            .length(
              8,
              `${translate(
                'incorrect_passport_please_enter_a_valid_passport',
              )}`,
            )
            .required(KYC_VALIDATION_REQUIRED_MSG)
            .trim()
        : Yup.string(),
    gst:
      vendorTypeSelected === 'BUSINESS'
        ? Yup.string()
            .length(
              15,
              `${translate(
                'invalid_gst_number_please_enter_a_valid_gst_number',
              )}`,
            )
            .matches(
              /^[0-9]{2}[A-Z|a-z|0-9]{13}$/,
              `${translate('invalid_gst_please_enter_a_valid_gst')}`,
            )
            .required(KYC_VALIDATION_REQUIRED_MSG)
            .trim()
        : Yup.string(),
    cin:
      vendorTypeSelected === 'BUSINESS'
        ? Yup.string()
            .length(21, `${translate('invalid_cin_please_enter_a_valid_cin')}`)
            .matches(
              /^([LUu]{1})([0-9]{5})([A-Za-z]{2})([0-9]{4})([A-Za-z]{3})([0-9]{6})$/,
              `${translate('invalid_cin_please_enter_a_valid_cin')}`,
            )
            .required(KYC_VALIDATION_REQUIRED_MSG)
            .trim()
        : Yup.string(),
    businessPan:
      vendorTypeSelected === 'BUSINESS'
        ? Yup.string()
            .length(10, `${translate('invalid_pan_please_enter_a_valid_pan')}`)
            .required(KYC_VALIDATION_REQUIRED_MSG)
            .trim()
        : Yup.string(),
    businessType:
      vendorTypeSelected === 'INDIVIDUAL' || vendorTypeSelected === 'BUSINESS'
        ? Yup.string().required(KYC_VALIDATION_REQUIRED_MSG)
        : Yup.string(),
    addressProof:
      vendorTypeSelected === 'INDIVIDUAL' && !isEditMode
        ? Yup.string().required(KYC_VALIDATION_REQUIRED_MSG)
        : Yup.string(),
  });
};

export default kycFormvalidationSchema;
